import { FC } from "react";
import { iDataUserRoles } from "../../../../interfaces/SuperAdmin/Pages/iDataUserRoles";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../ui-components/StyledTables";
import { Checkbox } from "@mui/material";
import { useAuthContext } from "../../../../hooks/Auth";

interface Props {
  user: iDataUserRoles;
  index: number;
  isSelected: boolean;
  handleSelect: (id: string) => void;
}

const RowSIngleUserRole: FC<Props> = ({
  user,
  index,
  isSelected,
  handleSelect,
}) => {
  const { canAccess } = useAuthContext();
  const isNotProfessor =
    canAccess("delete:roleApps") && canAccess("create:roleApps");
  return (
    <StyledTableRow key={user.id_usuario_rol}>
      {isNotProfessor && (
        <StyledTableCell>
          <Checkbox
            color="primary"
            checked={isSelected}
            onChange={() => handleSelect(user.id_usuario_rol)}
          />
        </StyledTableCell>
      )}
      <StyledTableCell>{index + 1}</StyledTableCell>
      <StyledTableCell>{user.nombres}</StyledTableCell>
      <StyledTableCell>{user.apellidos}</StyledTableCell>
      <StyledTableCell>{user.email}</StyledTableCell>
      <StyledTableCell>
        {new Date(user.created_at).toLocaleString()}
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default RowSIngleUserRole;
